import { useSelector } from 'react-redux';
import { MARKETING_PLUS_SUITE } from 'self-service-api/constants/BundleTypes';
import { MARKETING, SALES } from 'self-service-api/constants/ProductLines';
import { useAppSelector } from '../../reducers';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { bundleProductForBundleTypeAndProductLevelSelector, currentSkuIdForProductSelector, isQuantifiableSeatProOrEntSkuSelector, quantityPackForProductVersionSelector, skuSelector } from '../../selectors/ProductsSelectors';

// Cannot be used with a sku with multiple quantityPacks
export const useSkuAdditionalUnits = ({
  productLevel,
  productLine,
  bundleType
}) => {
  const skuId = useAppSelector(state => {
    if (bundleType) {
      const bundleProduct = bundleProductForBundleTypeAndProductLevelSelector(state, {
        bundleType,
        productLevel
      });
      return bundleProduct === null || bundleProduct === void 0 ? void 0 : bundleProduct.currentSkuId;
    }
    return currentSkuIdForProductSelector(state, {
      productLine,
      productLevel
    });
  });
  const isSeatsUngated = useAppSelector(isUngatedForSeatsSelector);
  const quantityPackSku = useAppSelector(state => {
    if (!skuId || !productLine) {
      return undefined;
    }
    return quantityPackForProductVersionSelector(state, {
      productVersionSkuId: skuId,
      quantityPackApiName: productLine === MARKETING || bundleType === MARKETING_PLUS_SUITE ? 'additional-marketing-contacts' : productLine === SALES ? 'additional-sales-seats' : 'additional-service-seats'
    });
  });
  const additionalUnitSkuId = useSelector(state => {
    if (!skuId || !productLine) {
      return;
    }
    const isSkuQuantifiable = skuSelector(state, {
      skuId
    }).quantifiable;
    if (isQuantifiableSeatProOrEntSkuSelector(state, {
      skuId
    }) && isSkuQuantifiable && isSeatsUngated) {
      return skuId;
    } else {
      return quantityPackSku === null || quantityPackSku === void 0 ? void 0 : quantityPackSku.skuId;
    }
  });
  return {
    additionalUnitSkuId,
    skuId
  };
};